const trustItems = [
  { icon: 'ri-award-line', title: 'Expert Reviewed', desc: 'Every product tested by category specialists' },
  { icon: 'ri-refresh-line', title: 'Updated Weekly', desc: 'Buying guides refreshed with the latest picks' },
  { icon: 'ri-store-3-line', title: '10,000+ Reviews', desc: 'Across 42 product categories and rising' },
  { icon: 'ri-scales-3-line', title: 'No Paid Rankings', desc: 'Independent from retailers and sponsors' },
];

const brandLogos = [
  { name: 'Apple',     style: 'font-semibold tracking-tight' },
  { name: 'SONY',      style: 'font-bold tracking-[0.15em]' },
  { name: 'SAMSUNG',   style: 'font-bold tracking-[0.08em]' },
  { name: 'BOSE',      style: 'font-bold tracking-[0.12em]' },
  { name: 'dyson',     style: 'font-light tracking-[0.25em]' },
  { name: 'GoPro',     style: 'font-black tracking-tight' },
  { name: 'PELOTON',   style: 'font-bold tracking-[0.2em]' },
  { name: 'Breville',  style: 'font-medium' },
  { name: 'Nintendo',  style: 'font-bold tracking-wide' },
  { name: 'LG',        style: 'font-black tracking-[0.3em]' },
  { name: 'Microsoft', style: 'font-semibold tracking-tight' },
  { name: 'NIKE',      style: 'font-black tracking-[0.18em]' },
];

export default function TrustBar() {
  const allBrands = [...brandLogos, ...brandLogos];

  return (
    <section className="py-12 border-b border-ink-100 bg-white reveal">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
          {trustItems.map((t) => (
            <div key={t.title} className="flex items-start gap-3">
              <i className={`${t.icon} text-xl text-ink-400 mt-0.5 flex-shrink-0`}></i>
              <div>
                <p className="text-sm font-semibold text-ink-900">{t.title}</p>
                <p className="text-sm text-ink-500 mt-0.5 leading-relaxed">{t.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-ink-100 pt-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-ink-400 text-center mb-6">
            Brands we&rsquo;ve reviewed
          </p>
          <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_8%,black_92%,transparent)]">
            <div className="flex gap-12 md:gap-16 animate-marquee whitespace-nowrap items-center">
              {allBrands.map((brand, i) => (
                <span
                  key={`${brand.name}-${i}`}
                  className={`flex-shrink-0 text-base text-ink-300 hover:text-ink-600 transition cursor-default select-none ${brand.style}`}
                >
                  {brand.name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
